import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

import * as formatters from '../../../common/formatters'

import VehiclesHistoryVehicles from './VehiclesHistoryVehicles'
import VehiclesHistoryList from './VehiclesHistoryList'

import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS_HISTORY } from '../permissions'

class VehiclesHistory extends Component {
    state = {
        selectedVehicle: null,
    }

    selectVehicle = vehicle => {
        this.setState({
            selectedVehicle: vehicle,
        })
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.vehicleHistory.heading' }))

        const selectedVehicle = this.state.selectedVehicle

        return (
            <PermissionsCheck hasAny={Object.values(PERMS_HISTORY)} noPermissionsPage>
                <div className={'page-inner '+(document.body.classList.contains('mobile-menu-open') ? 'sidebar-visible' : '')}>
                    <div id="main-wrapper">
                        <div className="panel panel-white">
                            <div className="panel-body">
                                <div className="row hp-100">
                                    <div className="col-md-6 hp-100 b-r">
                                        <div className="pull-left wp-100">
                                            <h4>
                                                <FormattedMessage id="modules.vehicleHistory.heading" />
                                            </h4>
                                        </div>
                                        <VehiclesHistoryVehicles selectedVehicle={selectedVehicle} onVehicleSelect={this.selectVehicle} />
                                    </div>
                                    <div className="col-md-6 hp-100">
                                        {selectedVehicle && <VehiclesHistoryList vehicle={selectedVehicle} showVehicleRegistration />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PermissionsCheck>
        )
    }
}

export default injectIntl(VehiclesHistory)
